var CONFIG = {
    project: {
        name: "Mike Ross - Portfolio",
        version: "10.1.21"
    },
    apiURL: {
        local: "http://localhost:97",
        production: "https://believeinyou.org/DataAPI/PortfolioSocialImpact"
    },
    timeline: {
        zoom: {
            initial: 35,
            scrubber: {
                width: 50,
                height: 50,
                arrowsWidth: 20
            },
            max: 100
        },
        order: "descending",
        height: "500px",
        dayHeight: 10,
        daysPerMonth: 30,
        navigation: {
            useScrollAction: false,
            useOverlayControls: false,
            scrubberWidth: {
                instance: 50,
                arrows: 20
            }
        },
        yBarWidth: {
            expanded: 350,
            collapsed: 70
        },
        projectTabWidth: 25
    },
    projects: {
        palette: {
            projectTitle: "#fff",
            clientYear: "#fff",
            backgroundColor: "#2c4168",
            copy: "#fff",
            timelineProjectDefault: "#ccc"
        },
        detailViewportHeight: 680,
        detailsWidth: 40,
        detailContentAnimationSpeed: 500,
        showSubNavigation: false
    },
    hosts: {
        accolades: "https://portfolio.alldreamstudios.com/Accolades"
    },
    profile: {
        featureImages: [
            "BGMain.jpg",
            "BGMain2.jpg",
            "BGMain3.jpg",
            "BGMain4.jpg",
            "BGMain5.jpg",
            "BGMain6.jpg",
            "BGMain8.jpg",
            "BGMain9.jpg",
            "BGMain10.jpg",
            "BGMain11.jpg"
        ],
        defaultLandingPage: "Main",
        animationCascadeOffset: 100
    },
    accolades: {
        showURLSourcesList: false
    }
};

module.exports = {
    CONFIG,
    profile: CONFIG.profile
};